// App.js
import { useEffect, useState } from "react";
// import "./App.css";
import "./etlsecound.css";
import hdfcs from './../../../assets/images/banks/thermax.png';
function VendorStatement() 
{
  

  return (
  <div>
   <table className="table">
    <tr>
        <td colspan="15" className="bold"><img src={hdfcs} alt="" height="70px" width="90px" />THERMAX LIMITED </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <br></br>
    <tr>
        <td colspan="15" className="bold">VENDOR NAME : SAGARBHANGA FOUNDRY AND ENGINEERING</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <br></br>
    <tr className="fontcolor">
        <td>DATE</td>
        <td>PARTICULARS</td>
        <td>VCH TYPE</td>
        <td>VCH NO.</td>
        <td>Cr/Dr</td>
        <td>DEBIT</td>
        <td>CREDIT</td>
        <td>BALANCE</td>
        <td>INVOICE/ PO NO.</td>
        <td>GRN NO</td>
        <td>GST AMT</td>
        <td>TDS AMT</td>
        <td>RETENTION</td>
        <td>UTR NO</td>
        <td>REFERENCE TEXT</td>
        <td>REMARKS</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12-04-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>6</td>
        <td>Cr</td>
        <td>0</td>
        <td>1736433.57</td>
        <td>1736433.57</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-04-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>47</td>
        <td>Dr</td>
        <td>181960.78</td>
        <td>0</td>
        <td>181960.78</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>20-04-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>12</td>
        <td>Cr</td>
        <td>0</td>
        <td>788172.58</td>
        <td>788172.58</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-05-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>27</td>
        <td>Cr</td>
        <td>0</td>
        <td>655671.1</td>
        <td>655671.10</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>21-05-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>225</td>
        <td>Dr</td>
        <td>121307.19</td>
        <td>0</td>
        <td>121307.19</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>27-05-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>29</td>
        <td>Cr</td>
        <td>0</td>
        <td>1854407</td>
        <td>1854407.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>05-06-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>33</td>
        <td>Cr</td>
        <td>0</td>
        <td>1395991.03</td>
        <td>1395991.03</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>09-06-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>37</td>
        <td>Cr</td>
        <td>0</td>
        <td>8387400</td>
        <td>8387400.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-06-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>43</td>
        <td>Cr</td>
        <td>0</td>
        <td>2120909</td>
        <td>2120909.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>24-06-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>46</td>
        <td>Cr</td>
        <td>0</td>
        <td>1436500</td>
        <td>1436500.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-06-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>47</td>
        <td>Cr</td>
        <td>0</td>
        <td>3526460</td>
        <td>3526460.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-06-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>440</td>
        <td>Dr</td>
        <td>303267.97</td>
        <td>0</td>
        <td>303267.97</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-06-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>441</td>
        <td>Dr</td>
        <td>2035247.26</td>
        <td>0</td>
        <td>2035247.26</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>13-07-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>51</td>
        <td>Cr</td>
        <td>0</td>
        <td>2119323</td>
        <td>2119323.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>22-07-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>53</td>
        <td>Cr</td>
        <td>0</td>
        <td>4722210</td>
        <td>4722210.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>22-07-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>54</td>
        <td>Cr</td>
        <td>0</td>
        <td>652304</td>
        <td>652304.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>22-07-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>634</td>
        <td>Cr</td>
        <td>0</td>
        <td>4727</td>
        <td>4727.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>26-07-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>58</td>
        <td>Cr</td>
        <td>0</td>
        <td>6114486</td>
        <td>6114486.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>26-07-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>656</td>
        <td>Cr</td>
        <td>0</td>
        <td>6121</td>
        <td>6121.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-07-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>672</td>
        <td>Dr</td>
        <td>1156199.46</td>
        <td>0</td>
        <td>1156199.46</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-07-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>673</td>
        <td>Dr</td>
        <td>1313700.14</td>
        <td>0</td>
        <td>1313700.14</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-08-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>64</td>
        <td>Cr</td>
        <td>0</td>
        <td>4893099</td>
        <td>4893099.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-08-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>820</td>
        <td>Cr</td>
        <td>0</td>
        <td>4898</td>
        <td>4898.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>27-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>885</td>
        <td>Dr</td>
        <td>1982855.95</td>
        <td>0</td>
        <td>1982855.95</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>27-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>886</td>
        <td>Dr</td>
        <td>2150946.78</td>
        <td>0</td>
        <td>2150946.78</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>28-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>891</td>
        <td>Dr</td>
        <td>2040970.48</td>
        <td>0</td>
        <td>2040970.48</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>895</td>
        <td>Dr</td>
        <td>2987584.95</td>
        <td>0</td>
        <td>2987584.95</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>902</td>
        <td>Dr</td>
        <td>400527.4</td>
        <td>0</td>
        <td>400527.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-08-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>903</td>
        <td>Dr</td>
        <td>95502.71</td>
        <td>0</td>
        <td>95502.71</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>09-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1036</td>
        <td>Dr</td>
        <td>1708894.29</td>
        <td>0</td>
        <td>1708894.29</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>09-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1037</td>
        <td>Dr</td>
        <td>582880.94</td>
        <td>0</td>
        <td>582880.94</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>09-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1038</td>
        <td>Dr</td>
        <td>1658066.44</td>
        <td>0</td>
        <td>1658066.44</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>09-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1039</td>
        <td>Dr</td>
        <td>555210.12</td>
        <td>0</td>
        <td>555210.12</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1054</td>
        <td>Dr</td>
        <td>10170.42</td>
        <td>0</td>
        <td>10170.42</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>14-09-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>72</td>
        <td>Cr</td>
        <td>0</td>
        <td>2597047.65</td>
        <td>2597047.65</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1066</td>
        <td>Dr</td>
        <td>903850.03</td>
        <td>0</td>
        <td>903850.03</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1067</td>
        <td>Dr</td>
        <td>451987.61</td>
        <td>0</td>
        <td>451987.61</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1116</td>
        <td>Dr</td>
        <td>404139.5</td>
        <td>0</td>
        <td>404139.50</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1117</td>
        <td>Dr</td>
        <td>1622298.63</td>
        <td>0</td>
        <td>1622298.63</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1118</td>
        <td>Dr</td>
        <td>301451.59</td>
        <td>0</td>
        <td>301451.59</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1119</td>
        <td>Dr</td>
        <td>2443126.69</td>
        <td>0</td>
        <td>2443126.69</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1150</td>
        <td>Dr</td>
        <td>3244976.4</td>
        <td>0</td>
        <td>3244976.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-09-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1151</td>
        <td>Dr</td>
        <td>3244976.4</td>
        <td>0</td>
        <td>3244976.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>01-10-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>79</td>
        <td>Cr</td>
        <td>0</td>
        <td>303263.56</td>
        <td>303263.56</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>06-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1296</td>
        <td>Dr</td>
        <td>10170.42</td>
        <td>0</td>
        <td>10170.42</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-10-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>85</td>
        <td>Cr</td>
        <td>0</td>
        <td>3725382.27</td>
        <td>3725382.27</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-10-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1327</td>
        <td>Cr</td>
        <td>0</td>
        <td>1680</td>
        <td>1680.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>19-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1328</td>
        <td>Dr</td>
        <td>3244976.4</td>
        <td>0</td>
        <td>3244976.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>27-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1377</td>
        <td>Dr</td>
        <td>2433732.3</td>
        <td>0</td>
        <td>2433732.30</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-10-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>91</td>
        <td>Cr</td>
        <td>0</td>
        <td>1369610.82</td>
        <td>1369610.82</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1402</td>
        <td>Dr</td>
        <td>1622488.2</td>
        <td>0</td>
        <td>1622488.20</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1403</td>
        <td>Dr</td>
        <td>1622488.2</td>
        <td>0</td>
        <td>1622488.20</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-10-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1404</td>
        <td>Dr</td>
        <td>811244.1</td>
        <td>0</td>
        <td>811244.10</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-10-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>92</td>
        <td>Cr</td>
        <td>0</td>
        <td>237104.04</td>
        <td>237104.04</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-10-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>93</td>
        <td>Cr</td>
        <td>0</td>
        <td>225848.12</td>
        <td>225848.12</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>02-11-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>96</td>
        <td>Cr</td>
        <td>0</td>
        <td>551527.42</td>
        <td>551527.42</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>05-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1544</td>
        <td>Dr</td>
        <td>109959.48</td>
        <td>0</td>
        <td>109959.48</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>05-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1545</td>
        <td>Dr</td>
        <td>109959.48</td>
        <td>0</td>
        <td>109959.48</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>10-11-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>100</td>
        <td>Cr</td>
        <td>0</td>
        <td>659918.34</td>
        <td>659918.34</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-11-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>101</td>
        <td>Cr</td>
        <td>0</td>
        <td>3754770.08</td>
        <td>3754770.08</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1602</td>
        <td>Cr</td>
        <td>0</td>
        <td>2750</td>
        <td>2750.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1603</td>
        <td>Cr</td>
        <td>0</td>
        <td>2750</td>
        <td>2750.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1604</td>
        <td>Dr</td>
        <td>1925</td>
        <td>0</td>
        <td>1925.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1605</td>
        <td>Dr</td>
        <td>1925</td>
        <td>0</td>
        <td>1925.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1614</td>
        <td>Dr</td>
        <td>109959.48</td>
        <td>0</td>
        <td>109959.48</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1615</td>
        <td>Dr</td>
        <td>102789.21</td>
        <td>0</td>
        <td>102789.21</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-11-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>103</td>
        <td>Cr</td>
        <td>0</td>
        <td>9268226</td>
        <td>9268226.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1620</td>
        <td>Cr</td>
        <td>0</td>
        <td>9278</td>
        <td>9278.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>23-11-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>105</td>
        <td>Cr</td>
        <td>0</td>
        <td>4942359</td>
        <td>4942359.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>23-11-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1652</td>
        <td>Cr</td>
        <td>0</td>
        <td>4947</td>
        <td>4947.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1693</td>
        <td>Dr</td>
        <td>384858.18</td>
        <td>0</td>
        <td>384858.18</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1694</td>
        <td>Dr</td>
        <td>1630908.09</td>
        <td>0</td>
        <td>1630908.09</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1695</td>
        <td>Dr</td>
        <td>384858.18</td>
        <td>0</td>
        <td>384858.18</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-11-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1696</td>
        <td>Dr</td>
        <td>1871209.49</td>
        <td>0</td>
        <td>1871209.49</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>06-12-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>107</td>
        <td>Cr</td>
        <td>0</td>
        <td>1319165.4</td>
        <td>1319165.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>06-12-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1827</td>
        <td>Cr</td>
        <td>0</td>
        <td>2750</td>
        <td>2750.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>06-12-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1828</td>
        <td>Dr</td>
        <td>1925</td>
        <td>0</td>
        <td>1925.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>13-12-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>109</td>
        <td>Cr</td>
        <td>0</td>
        <td>5509.92</td>
        <td>5509.92</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>13-12-21</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>1864</td>
        <td>Cr</td>
        <td>0</td>
        <td>351</td>
        <td>351.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>14-12-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1873</td>
        <td>Dr</td>
        <td>1359090.08</td>
        <td>0</td>
        <td>1359090.08</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>26-12-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1953</td>
        <td>Dr</td>
        <td>847535</td>
        <td>0</td>
        <td>847535.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-12-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>114</td>
        <td>Cr</td>
        <td>0</td>
        <td>80934.5</td>
        <td>80934.50</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>29-12-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1977</td>
        <td>Dr</td>
        <td>1536358.23</td>
        <td>0</td>
        <td>1536358.23</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>30-12-21</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>117</td>
        <td>Cr</td>
        <td>0</td>
        <td>164394.52</td>
        <td>164394.52</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-12-21</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>1997</td>
        <td>Dr</td>
        <td>921814.94</td>
        <td>0</td>
        <td>921814.94</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>05-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>118</td>
        <td>Cr</td>
        <td>0</td>
        <td>14568.21</td>
        <td>14568.21</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>11-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>119</td>
        <td>Cr</td>
        <td>0</td>
        <td>2638331.3</td>
        <td>2638331.30</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>11-01-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2139</td>
        <td>Cr</td>
        <td>0</td>
        <td>5499</td>
        <td>5499.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>11-01-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2140</td>
        <td>Dr</td>
        <td>3850</td>
        <td>0</td>
        <td>3850.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>13-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>123</td>
        <td>Cr</td>
        <td>0</td>
        <td>89179.56</td>
        <td>89179.56</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>14-01-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2174</td>
        <td>Dr</td>
        <td>1152647.6</td>
        <td>0</td>
        <td>1152647.60</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>127</td>
        <td>Cr</td>
        <td>0</td>
        <td>5038969</td>
        <td>5038969.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-01-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2193</td>
        <td>Cr</td>
        <td>0</td>
        <td>5044</td>
        <td>5044.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>20-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>129</td>
        <td>Cr</td>
        <td>0</td>
        <td>662353.59</td>
        <td>662353.59</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>21-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>130</td>
        <td>Cr</td>
        <td>0</td>
        <td>125801.1</td>
        <td>125801.10</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>24-01-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2249</td>
        <td>Dr</td>
        <td>1599391.47</td>
        <td>0</td>
        <td>1599391.47</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>131</td>
        <td>Cr</td>
        <td>0</td>
        <td>75480.66</td>
        <td>75480.66</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-01-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>134</td>
        <td>Cr</td>
        <td>0</td>
        <td>720702.79</td>
        <td>720702.79</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-01-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2293</td>
        <td>Dr</td>
        <td>1433934.35</td>
        <td>0</td>
        <td>1433934.35</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2475</td>
        <td>Dr</td>
        <td>204847.76</td>
        <td>0</td>
        <td>204847.76</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>15-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2497</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-02-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>139</td>
        <td>Cr</td>
        <td>0</td>
        <td>374004.64</td>
        <td>374004.64</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-02-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2506</td>
        <td>Cr</td>
        <td>0</td>
        <td>3235</td>
        <td>3235.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-02-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2507</td>
        <td>Dr</td>
        <td>2264</td>
        <td>0</td>
        <td>2264.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-02-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>140</td>
        <td>Cr</td>
        <td>0</td>
        <td>274117.5</td>
        <td>274117.50</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>17-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2519</td>
        <td>Dr</td>
        <td>26432</td>
        <td>0</td>
        <td>26432.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>18-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2524</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-02-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>144</td>
        <td>Cr</td>
        <td>0</td>
        <td>61097.4</td>
        <td>61097.40</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>26-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2591</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>28-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2602</td>
        <td>Dr</td>
        <td>2273721.11</td>
        <td>0</td>
        <td>2273721.11</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>28-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2603</td>
        <td>Dr</td>
        <td>2273721.11</td>
        <td>0</td>
        <td>2273721.11</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>28-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2604</td>
        <td>Dr</td>
        <td>2273721.11</td>
        <td>0</td>
        <td>2273721.11</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>28-02-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2605</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>01-03-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>146</td>
        <td>Cr</td>
        <td>0</td>
        <td>7913101</td>
        <td>7913101.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>01-03-22</td>
        <td>Tax Deducted at Source (F.Y 2021-22)-NSDL</td>
        <td>Journal</td>
        <td>2706</td>
        <td>Cr</td>
        <td>0</td>
        <td>7921</td>
        <td>7921.00</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>07-03-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>150</td>
        <td>Cr</td>
        <td>0</td>
        <td>1177809.31</td>
        <td>1177809.31</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>16-03-22</td>
        <td>Canara Bank-CC( 4163261000013)/8019777.73/-</td>
        <td>Receipt</td>
        <td>154</td>
        <td>Cr</td>
        <td>0</td>
        <td>582931.05</td>
        <td>582931.05</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>22-03-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2796</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>MATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>25-03-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2810</td>
        <td>Dr</td>
        <td>1786495.16</td>
        <td>0</td>
        <td>1786495.16</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>31-03-22</td>
        <td>Fabrication Machining</td>
        <td>Journal</td>
        <td>2857</td>
        <td>Dr</td>
        <td>3248173.02</td>
        <td>0</td>
        <td>3248173.02</td>
        <td></td>
        <td></td>
        <td>0.00</td>
        <td>0.00</td>
        <td></td>
        <td></td>
        <td></td>
        <td>UNMATCHED</td>
    </tr>
</table>
  </div>
  )
}



export default VendorStatement;